import { useMemo } from "react";
import styles from "./NBLogo.module.css";

const NBLogo = () => {
  return (
    <img
      className={styles.logo}
      alt=""
      src="./logo.png"
      onClick={() => window.open('https://www.newbalance.com/')}
    />
  );
};

export default NBLogo;
